import ResumeComparison from './ResumeComparison';
import APIExplorer from './APIExplorer';
import DiscoverableCTA from './DiscoverableCTA';

const SECTIONS = [
  { id: 'comparison', label: 'PDF vs API' },
  { id: 'explorer', label: 'API Explorer' },
  { id: 'discoverable', label: 'Get Discoverable' },
] as const;

export default function CandidateView() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-6 py-10 space-y-16">
      {/* Intro */}
      <div className="max-w-3xl">
        <h1 className="text-4xl sm:text-5xl font-bold text-ti-text mb-4 leading-tight">
          The Candidate Side
        </h1>
        <p className="text-lg text-ti-text-muted leading-relaxed mb-6">
          The resume is a PDF. The future is an API. See what happens when your
          professional identity becomes structured, queryable data.
        </p>

        {/* Section anchor links */}
        <nav className="flex flex-wrap gap-2">
          {SECTIONS.map((s) => (
            <button
              key={s.id}
              onClick={() => scrollTo(s.id)}
              className="px-3 py-1.5 text-sm text-ti-text-muted border border-ti-border rounded-lg hover:border-ti-blue/40 hover:text-ti-blue transition-colors cursor-pointer"
            >
              {s.label}
            </button>
          ))}
        </nav>
      </div>

      {/* Section 1: Resume vs API Comparison */}
      <ResumeComparison />

      {/* Section 2: Interactive API Explorer */}
      <APIExplorer />

      {/* Section 3: Make Yourself Discoverable CTA */}
      <DiscoverableCTA />
    </div>
  );
}
